import MathManager from '@/utils/math-manager.utils'
import {
  RECEIVERS_TYPE_ENUM,
  isReceiversTypeSplit
} from '../../enums/receivers-type.enum'
import {
  isRefundTypeTotal,
  isRefundTypePartial
} from '../../enums/refund-type.enum'
import { SPLIT_ENUM, isAllTypeSplit } from '../../enums/splits.enum'
import BoletoCancelContainerManager from '../../boleto-cancel-container.manager'

class RefundTypeManager {
  constructor (data) {
    this.data = data
  }

  static moneyFormat () {
    return {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false
    }
  }

  convertedTotalAmountCurrency () {
    return MathManager.formatCurrencyBRL(this.data.totalAmount)
  }

  shouldDisplayError () {
    return this.data.amount > this.data.totalAmount
  }

  receiversType () {
    return this.data.initialChargeSplit?.length > 1
      ? RECEIVERS_TYPE_ENUM.SPLIT
      : RECEIVERS_TYPE_ENUM.SINGLE
  }

  getRecipientNameBasedOnSplitId (recipientId) {
    return BoletoCancelContainerManager.findRecipientNameBySplitId(
      this.data.initialChargeSplit,
      recipientId
    )
  }

  shouldDisplaySplitsSelect () {
    // only display the splits select if the refund type is partial and we have charge split
    return (
      isRefundTypePartial(this.data.refundType) &&
      isReceiversTypeSplit(this.receiversType())
    )
  }

  prepareInitialValues () {
    //
    return {
      ...this.data.initialValues,
      amount: this.data.initialValues.amount / 100,
      split: Array.isArray(this.data.initialValues.split)
        ? SPLIT_ENUM.ALL
        : this.data.initialValues.split
    }
  }

  prepareAmount () {
    // if is TOTAL refund type, then we use the total amount
    // else we use the provided amount in the money input
    return isRefundTypeTotal(this.data.refundType)
      ? this.data.totalAmount
      : this.data.amount * 100
  }

  prepareSplit () {
    // if the current charge does not have split, then we do not use the split option
    if (!isReceiversTypeSplit(this.receiversType())) return

    // if we select the ALL split rule (default) then we map all the recipients ids
    if (isAllTypeSplit(this.data.split))
      return this.data.initialChargeSplit.map(receiver => receiver.recipient.id)

    // otherwise we just return the selected recipient
    return this.data.split
  }

  prepareDataForSubmission () {
    // if the refund type is TOTAL then use the totalAmount
    return {
      refundType: this.data.refundType,
      amount: this.prepareAmount(),
      split: this.prepareSplit()
    }
  }
}

export default RefundTypeManager
